import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const SafeRedirect = ({ path, replace, onCleanUp }) => {
  useEffect(() => {
    if (path && path.trim()) {
      onCleanUp();
    }
  }, [path, replace]);

  if (path && path.trim()) {
    return <Navigate to={path} replace={replace} />;
  }
  return null;
};

SafeRedirect.propTypes = {
  path: PropTypes.string,
  replace: PropTypes.bool,
  onCleanUp: PropTypes.func,
};

SafeRedirect.defaultProps = {
  path: '',
  replace: false,
  onCleanUp: () => {},
};

export default SafeRedirect;
